<template>
	<div id="centreRight">
		<dv-border-box-6>
			<div class="d-flex pt-2 pl-2">
				<div class="d-flex">
					<span class="mt-3 ml-3 title_t">运行负载率</span>
				</div>
			</div>
			<div class="d-flex jc-center">
				<div id="centerRightLine" style="width: 5rem; height: 2.8rem;"></div>
			</div>
		</dv-border-box-6>
	</div>
</template>

<script>
	import echarts from "echarts"
	export default {
		data() {
			return {
				chart: null,
			};
		},
		props: ['centerRightData'],
		watch: {
			'centerRightData': {
				handler() {
					this.draw();
				},
				deep: true
			}
		},
		mounted() {

		},
		methods: {
			draw() {
				// 基于准备好的dom，初始化echarts实例
				this.chart = this.$echarts.init(
					document.getElementById("centerRightLine"), 'dark'
				);
				
				let data = this.centerRightData
				let maxList = [
					data.Central_China.max.toFixed(1),
					data.East_China.max.toFixed(1),
					data.North_China.max.toFixed(1),
					data.North_West.max.toFixed(1),
					data.South_China.max.toFixed(1),
					data.South_West.max.toFixed(1),
				]
				let precentList = [
					data.Central_China.precent.toFixed(1),
					data.East_China.precent.toFixed(1),
					data.North_China.precent.toFixed(1),
					data.North_West.precent.toFixed(1),
					data.South_China.precent.toFixed(1),
					data.South_West.precent.toFixed(1),
				]
				let currentList = [
					data.Central_China.current.toFixed(1),
					data.East_China.current.toFixed(1),
					data.North_China.current.toFixed(1),
					data.North_West.current.toFixed(1),
					data.South_China.current.toFixed(1),
					data.South_West.current.toFixed(1),
				]

				let option = {
					tooltip: {
						formatter: function(params) {
							return '运行冷量：' + currentList[params.dataIndex] + "<br />" +
								'运行负载率：' + precentList[params.dataIndex] + '%' + "<br />" +
								'配置冷量：' + maxList[params.dataIndex]
						}
					},
					backgroundColor: 'rgb(255,255,255,0)', //背景色
					grid: {
						left: 50
					},
					xAxis: {
						type: "category",
						data: ["华中", "华东", "华北", "西北", "华南", "西南"],
						axisLabel: {
							show: true,
							textStyle: {
								color: 'lightgray'
							}
						},
						axisTick: {
							show: false
						}
					},
					yAxis: {
						type: "value",
						name: "kw",
						nameTextStyle: {
							color: 'lightgray'
						},
						// min: 0,
						// max: 100,
						axisLabel: {
							formatter: function(value) {
								if (value >= 1000) {
									value = value / 1000 + "k";
								} else if (value < 1000) {
									value;
								}
								return value;
							},
							textStyle: {
								color: 'lightgray'
							}
						},
						splitLine: {
							show: true,
							lineStyle: {
								color: '#323232',
								type: "dashed"
							}
						}
					},
					series: [{
						type: "bar",
						smooth: true,
						data: maxList,
						itemStyle: {
							normal: {
								color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
									offset: 0,
									color: 'rgba(245,123,1,1)'
								}, {
									offset: 0.5,
									color: 'rgba(245,123,1,0.6)'
								}], false)
							}
						},
						barWidth: 20
					}, ],
				};

				this.chart.setOption(option);
			},
		},
	};
</script>

<style lang="scss">
	#centreRight {
		// padding: 0.2rem;
		height: 3.125rem;
		width: 5.125rem;
	}
</style>
